
import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import Awards from './components/Awards';
import PhotoGallery from './components/PhotoGallery';
import VideoGallery from './components/VideoGallery';
import PersonalLife from './components/PersonalLife';
import Footer from './components/Footer';

export default function Home() {
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsNavbarFixed(true);
    } else {
      setIsNavbarFixed(false);
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll);
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar isFixed={isNavbarFixed} />
      <Hero />
      <AboutMe />
      <Awards />
      <PhotoGallery />
      <VideoGallery />
      <PersonalLife />
      <Footer />
    </div>
  );
}
